import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MomentModule } from 'angular2-moment';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";

import { AdminAreaComponent } from './admin-area.component';
import { AdminAreaDoctorsComponent } from './doctors/admin-area-doctors.component';
import { AdminAreaUsersComponent } from './users/admin-area-users.component';

import { AdminService } from 'app/admin/admin.service';

const AdminRoutes: Routes = [
	{ path: 'admin', component: AdminAreaComponent, children: [
		{ path: '', redirectTo: 'doctors', pathMatch: 'full' },
        { path: 'doctors', component: AdminAreaDoctorsComponent },
        { path: 'users', component: AdminAreaUsersComponent, data: { Type: "admin" } },
        { path: 'client-users', component: AdminAreaUsersComponent, data: { Type: "client" } }
    ], canActivate: [AuthGuard] }
];

@NgModule({
	imports: [
		CommonModule,
        FormsModule,
		RouterModule.forChild(AdminRoutes),
        MomentModule,
        ModalModule,
        SharedModule
	],
	declarations: [
		AdminAreaComponent,
        AdminAreaDoctorsComponent,
        AdminAreaUsersComponent
    ],
    providers: [
        AdminService
    ]
})
export class AdminAreaModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin-area.module.ts